/**
 * Created by anthony on 4/18/14.
 */
var housingService = angular.module('housingService', []);
housingService.factory('HousingService', function(ApplicationService){

    var getOrignalHousing = function ()
    {
        var orignalHousing = {};
        orignalHousing.Rea_Mort_Pay = "0";
        orignalHousing.Rea_Property_Tax = "0";
        for(var i = 0; i < ApplicationService.getFamilyData().real_estate.length; i++)
        {
            if (ApplicationService.getFamilyData().real_estate[i].Rea_Description == "Family Home")
            {
                orignalHousing.Rea_Property_Inc = ApplicationService.getFamilyData().real_estate[i].Rea_Property_Inc;
                orignalHousing.Rea_Home_Ins = ApplicationService.getFamilyData().real_estate[i].Rea_Home_Ins;
                orignalHousing.Rea_Mort_Pay = ApplicationService.getFamilyData().real_estate[i].Rea_Mort_Pay;
                orignalHousing.Rea_Property_Tax = ApplicationService.getFamilyData().real_estate[i].Rea_Property_Tax;
            }
        }
        return orignalHousing;
    }
    return {
        getOrignalHousing: getOrignalHousing
    }



});